import * as client_hooks from '../../../src/hooks.client.ts';
import * as universal_hooks from '../../../src/hooks.ts';

export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37'),
	() => import('./nodes/38'),
	() => import('./nodes/39'),
	() => import('./nodes/40'),
	() => import('./nodes/41'),
	() => import('./nodes/42'),
	() => import('./nodes/43')
];

export const server_loads = [0,2];

export const dictionary = {
		"/(marketing)": [10,[2]],
		"/app": [~18,[5]],
		"/app/ai": [19,[5]],
		"/app/ai/[conversation_id]": [20,[5]],
		"/app/consent": [21,[5]],
		"/app/insights": [22,[5]],
		"/app/integrations": [23,[5]],
		"/app/integrations/strava": [~24,[5]],
		"/app/journal": [25,[5]],
		"/app/onboarding": [26,[5]],
		"/app/stats": [27,[5]],
		"/app/trackers": [28,[5]],
		"/app/trackers/create": [31,[5]],
		"/app/trackers/new": [32,[5,6]],
		"/app/trackers/[id]": [29,[5]],
		"/app/trackers/[id]/edit": [30,[5]],
		"/auth/login": [~33],
		"/auth/register": [~34],
		"/category/[slug]": [35,[7]],
		"/(marketing)/changelog": [11,[2]],
		"/(marketing)/features": [12,[2]],
		"/(marketing)/pricing": [13,[2]],
		"/(marketing)/privacy": [~14,[2]],
		"/settings": [36,[9]],
		"/settings/archive": [37,[9]],
		"/settings/billing": [38,[9]],
		"/settings/categories": [39,[9]],
		"/settings/notifications": [40,[9]],
		"/settings/preferences": [41,[9]],
		"/settings/privacy": [42,[9]],
		"/settings/trash": [43,[9]],
		"/(marketing)/terms": [~15,[2]],
		"/(wiki)/wiki": [16,[3,4]],
		"/(wiki)/wiki/[...slug]": [17,[3,4]]
	};

export const hooks = {
	handleError: client_hooks.handleError || (({ error }) => { console.error(error) }),
	init: client_hooks.init,
	reroute: universal_hooks.reroute || (() => {}),
	transport: universal_hooks.transport || {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));
export const encoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.encode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.js';